<template>
	<div class="line-chart">
		<canvas class="line-chart__chart" :id="`js_lineChart${chartIndex}`"></canvas>
	</div>
</template>

<script>
import moment from 'moment'
import Chart from 'chart.js/auto'
moment.locale('ja')

export default {
	name: 'LineChart',
	props: {
		labels: {
			type: Array,
			required: true
		},
		datapoints: {
			type: Array,
			required: true
		},
		chartIndex: {
			type: Number,
			required: true
		},
		displayType: {
			type: String,
			required: true
		},
		yAxisMaxValue: {
			type: Number,
			required: true
		}
	},
	data () {
		return {
			lineChart: null
		}
	},
	mounted () {
		this.initChart()
	},
	methods: {
		initChart () {
			// グラフ描画コンテキスト取得
			const ctx = document.getElementById(`js_lineChart${this.chartIndex}`)

			// ラインチャートの設定
			const data = {
				labels: this.labels,
				datasets: [{
					label: '',
					data: this.datapoints,
					borderColor: '#F95959',
					pointRadius: 1,
					borderWidth: 2,
					fill: false,
					tension: 0.1,
					spanGaps: true
				}]
			}

			// オプション設定
			const options = {
				responsive: true,
				maintainAspectRatio: false,
				scales: {
					x: {
						beginAtZero: true,
						ticks: {
							color: '#666666',
							size: 8,
							weight: 500,
							family: `'M+ C Type-1 (basic latin) Medium', 'M+ Type-1 (general-j) Medium', M+ C Type-1 (basic latin) Regular', 'M+ Type-1 (general-j) Regular', 'sans-serif'`,
							callback: (value, index, values) => {
								if (this.displayType === '1month') {
									const date = moment(this.labels[index])
									if (date.day() === 1) {
										return date.format('M/D')
									}
								} else if (this.displayType === '6month') {
									const date = moment(this.labels[index])
									if (date.date() === 1) {
										return date.format('M')
									}
								} else if (this.displayType === 'year') {
									const date = moment(this.labels[index])
									if (date.date() === 1) {
										return date.format('M')
									}
								}
							}
						}
					},
					y: {
						beginAtZero: true,
						max: this.yAxisMaxValue,
						min: 0,
						ticks: {
							stepSize: 25,
							color: '#666666',
							size: 8,
							weight: 500,
							family: `'M+ C Type-1 (basic latin) Medium', 'M+ Type-1 (general-j) Medium', M+ C Type-1 (basic latin) Regular', 'M+ Type-1 (general-j) Regular', 'sans-serif'`
						}
					}
				},
				plugins: {
					legend: {
						display: false
					},
					tooltip: {
						enabled: false
					}
				},
				animation: false
			}

			// チャートの描画
			this.lineChart = new Chart(ctx, {
				type: 'line',
				data: data,
				options: options
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variable";

// NOTE: デザインシステム外のため他での利用禁止

.line-chart {
	width: 100%;
	height: 160px;
}
</style>
